import { EmptystateMagnetColored } from "components/icons/generated";
import CardCollapsible from "ds/components/Card/Collapsible";
import useAutoExpandOnValueChange from "ds/components/Card/Collapsible/useAutoExpandOnValueChange";
import Counter from "ds/components/Counter";
import EmptyState from "ds/components/EmptyState";
import { useToggle } from "hooks/useToggle";

import NewModuleAttachedPolicy from "../AttachedPolicy";
import { AutoAttachedPolicy } from "../types";

type NewModuleAutoAttachedPoliciesProps = {
  items: AutoAttachedPolicy[];
};

const NewModuleAutoAttachedPolicies = ({ items }: NewModuleAutoAttachedPoliciesProps) => {
  const [isCollapsed, toggle] = useToggle(true);

  useAutoExpandOnValueChange(items.length, toggle);

  return (
    <CardCollapsible
      ariaLevel={3}
      ariaLabel="Auto-attached"
      title="Auto-attached"
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={items.length} />}
      contentGap="medium"
    >
      {items.length === 0 ? (
        <EmptyState
          padding="large"
          icon={EmptystateMagnetColored}
          title="No policies are auto-attached to this module"
          caption="Use auto-attach label to attach policy automatically."
        />
      ) : (
        <>
          {items.map((item) => (
            <NewModuleAttachedPolicy key={item.id} item={item} headingLevel={4} />
          ))}
        </>
      )}
    </CardCollapsible>
  );
};

export default NewModuleAutoAttachedPolicies;
